export enum STORAGE_KEYS {
  REACTION_TOOLTIP = 'reactionTooltip',
  JOYRIDE_TOUR = 'joyrideTour'
}

export enum DISCOVERY_TOUR_STEPS_KEYS {
  REACTION_BUTTON = '.reaction-button',
  FILTER_BUTTON = '.filter-button'
}

export const TOUR_KEYS = {
  DISCOVERY: 'discovery'
} as const;